import api from "./instance";
import { pickData } from "./util";
import { User as User2 } from "./auth";

/**
 * Types
 */

export type User = User2;

/**
 * Endpoints
 */

export const getListOfUsers = () => api.get<User[]>(`/users`).then(pickData);

export const createUser = (user: Omit<User, "id">) =>
  api.post<User & { password: string }>("/users", user).then(pickData);

export const updateUser = (userId: string, partial: Partial<User>) =>
  api.put(`/users/${userId}`, partial);

export const resetPassword = (userId: string) =>
  api.put<{ password: string }>(`/users/${userId}/password`).then(pickData);

export const deleteUser = (userId: string) => api.delete(`/users/${userId}`);
